import React from 'react';
import { Card } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export default function CourtPicker({
  sport, setSport,
  quantity, changeQuantity,
  timeSlot, locationId,
  allCourtsCount, availableCourts, selectedCourts,
  loadingAvail, toggleCourt,
}) {
  return (
    <Card className="p-4 space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label className="text-xs uppercase font-bold text-muted-foreground mb-1 block">Sport</Label>
          <Select value={sport} onValueChange={setSport}>
            <SelectTrigger data-testid="sport-select"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="badminton">Badminton</SelectItem>
              <SelectItem value="pickleball">Pickleball</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label className="text-xs uppercase font-bold text-muted-foreground mb-1 block">Courts Needed</Label>
          <Select value={String(quantity)} onValueChange={(v) => changeQuantity(parseInt(v, 10))}>
            <SelectTrigger data-testid="qty-select"><SelectValue /></SelectTrigger>
            <SelectContent>
              {[1, 2, 3, 4, 5].map((q) => (
                <SelectItem key={q} value={String(q)}>{q}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>

      <div>
        <Label className="text-xs uppercase font-bold text-muted-foreground mb-2 block">
          Pick Court{quantity > 1 ? 's' : ''} {loadingAvail && <span className="text-muted-foreground">(checking…)</span>}
        </Label>
        {(!timeSlot || !locationId) ? (
          <p className="text-sm text-muted-foreground italic">Pick location, date, and start time first.</p>
        ) : allCourtsCount === 0 ? (
          <p className="text-sm text-muted-foreground italic">No courts configured at this location.</p>
        ) : (
          <div className="flex flex-wrap gap-2">
            {Array.from({ length: allCourtsCount }, (_, i) => i + 1).map((num) => {
              const isAvailable = availableCourts.includes(num);
              const isSelected = selectedCourts.includes(num);
              return (
                <button
                  key={num}
                  type="button"
                  disabled={!isAvailable}
                  onClick={() => toggleCourt(num)}
                  data-testid={`court-${num}`}
                  className={`min-w-[64px] py-2 px-3 rounded-xl border text-sm font-bold transition-all ${
                    !isAvailable
                      ? 'bg-red-50 text-red-400 border-red-200 cursor-not-allowed line-through'
                      : isSelected
                        ? 'bg-emerald-600 text-white border-emerald-600 shadow-md'
                        : 'bg-white text-slate-700 border-slate-300 hover:bg-emerald-50 hover:border-emerald-300'
                  }`}
                >
                  Court {num}
                </button>
              );
            })}
          </div>
        )}
      </div>
    </Card>
  );
}
